var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 14a2 2 0 0 1 1.732 1H18a1 1 0 0 1 0 2l-7.268.001a2 2 0 0 1-3.464 0L6 17a1 1 0 0 1 0-2h1.268A2 2 0 0 1 9 14Zm6-4a2 2 0 0 1 1.732 1H18a1 1 0 0 1 0 2l-1.268.001a2 2 0 0 1-3.464 0L6 13a1 1 0 0 1 0-2h7.268A2 2 0 0 1 15 10ZM9 6a2 2 0 0 1 1.732 1H18a1 1 0 0 1 0 2l-7.268.001a2 2 0 0 1-3.464 0L6 9a1 1 0 1 1 0-2h1.268A2 2 0 0 1 9 6Z",
  fill: "currentColor"
})));
export default SvgFilter;